import { APIClient } from "api/api_helper";
import { BOX_LABEL_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const BoxLabelApiService = {
    // SELECT ALL BOX LABEL
    selectAll: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;
        const aliquotId = payload_data.aliquot && (Array.isArray(payload_data.aliquot) ? !payload_data.aliquot.includes("ALL") && payload_data.aliquot.length > 0 ? payload_data.aliquot.map((id: any) => Number(id)) : null : payload_data.aliquot !== "ALL" ? [Number(payload_data.aliquot)] : null);

        const payload = {
            compid: (user as any)?.compid,
            branid: (user as any)?.branid,
            studyid: payload_data.studyid,
            periodnumber: payload_data.period && payload_data.period !== "ALL" ? String(payload_data.period) : null,
            currentpage: payload_data.currentpage ?? 1,
            pagesize: payload_data.pagesize ?? 10,
            searchtext: payload_data.searchtext && String(payload_data.searchtext).trim() ? String(payload_data.searchtext).trim() : null,
            database: (user as any)?.database || sessionStorage.getItem("database") || "ZENTIXS_VISTA_2.0",
            aliquotid: aliquotId,
        };
        return api.create(sessionStorage.getItem("baseUrl") + "BoxLabelHistory/SelectAll", payload);
    },
    // UPDATE BOX LABEL PRINT
    updateLabel: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            compid: (user as any)?.compid,
            database: (user as any)?.database || sessionStorage.getItem("database") || "ZENTIXS_VISTA_2.0",
            branid: (user as any)?.branid,
            studyid: payload_data.studyid,
            dispatchbox: payload_data.dispatchbox || [],
            printby: user?.userid,
        };
        return api.create(sessionStorage.getItem("baseUrl") + "BoxLabelHistory/Update", payload);
    },
    // INSERT BOX LABEL REPRINT HISTORY
    insertHistory: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            compid: (user as any)?.compid,
            branid: (user as any)?.branid,
            studyid: payload_data.studyid,
            printby: user?.userid,
            verifiedby: null,
            reasonforreprint: payload_data.reasonforreprint ? parseInt(payload_data.reasonforreprint, 10) : null,
            additionalcomments: payload_data.additionalcomments || null,
            printcount: payload_data.printcount || 1,
            database: (user as any)?.database || sessionStorage.getItem("database") || "ZENTIXS_VISTA_2.0",
            jsondata: payload_data.jsondata || [],
        };
        return api.create(sessionStorage.getItem("baseUrl") + "BoxLabelHistory/Insert", payload);
    },
};
